<div
  *ngIf="!bphChange.hide && !showAddEditTableForm && !confChange.showDetails && !bphChange.showDetails && !globalConf.showDetails"
  [ngClass]="bphChange.error[selectedLanguage] ? 'hasError' : 'noError'"
  class="{{bphChange.error_class}} hide_{{bphChange.show}}" style="margin-bottom: 1.34375em">
  <div *ngIf="bphChange.error && bphChange.error[selectedLanguage]" class="formFieldError">
    {{bphChange.error[selectedLanguage]}}
  </div>

  <ng-container *ngFor="let table of bphChange.budgetTables; let tableIndex = index;">
    <ng-container>
      <div [ngClass]="table && table.error && table.error[selectedLanguage] ? 'hasError' : 'noError'">
        <span *ngIf="table && table.error && table.error[selectedLanguage]"
          class="formFieldError">{{table.error[selectedLanguage]}}</span>
      </div>
      <table class="angular-table">
        <ng-container>
          <thead class="angular-table-thead"> 
            <tr *ngIf="table.showLabel" class="angular-table-tr header-table">
              <th colspan="10" class="angular-table-th" style="padding:0 !important;">
                <div
                  style="display: flex; align-items: center; justify-content: space-between; width: 100%; height: 100%;">
                  <div style="display: flex; align-items: center; gap: 8px; cursor: pointer;"
                    (click)="toggleTable(table)">
                    <mat-icon *ngIf="table.teamFunded === '1'" style="cursor: pointer;margin-left: 20px;"
                      (click)="$event.stopPropagation(); toggleTable(table)">
                      {{table.hidden ? 'add_circle_outline' : 'remove_circle_outline'}}
                    </mat-icon>

                    <div class="table-label-stack">
                      <ng-container *ngFor="let line of getLabelLines(table); let i = index">
                        <span class="table-label-line">{{ line }}</span>
                      </ng-container>
                    </div>

                  </div>
                  <div *ngIf="table.id>1" style="display:flex; align-items:center; gap:12px;">
                    <label id="example-radio-group-label" style="cursor: pointer;">
                      <span style="color: red">* </span>{{getTranslatedLabel('ecase.admindashboard.budgect.requestedbudget')}}
                    </label>
                    <mat-radio-group (click)="checkForSelectNo($event,table); " aria-labelledby="teamFunded"
                      style="cursor: pointer;" [(ngModel)]="table.teamFunded">
                      <mat-radio-button value="1">{{getTranslatedLabel('ecase.taxonomy.1.1')}}</mat-radio-button>&nbsp;
                      <mat-radio-button value="2">{{getTranslatedLabel('ecase.taxonomy.1.2')}}</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </th>
            </tr>
            <!-- HEADERS ROW START -->
            <tr [hidden]="table.hidden || table.teamFunded !== '1'" class="angular-table-tr">
              <ng-container>
                <th *ngIf="!confChange.hideYearsExpenditure" class="angular-table-th"></th>
                <ng-template [ngForOf]="getFilteredSubBlocks()" let-aBlock ngFor>
                  <th *ngIf="!aBlock.hideCell"
                    [ngClass]="aBlock.align ? (aBlock.align.includes('left') ? 'align-start' : (aBlock.align.includes('right') ? 'align-end' : 'align-center')) : 'align-center'"
                    [style.width.%]="(confChange.isWidthSpecifiedForSubBlocks && aBlock.columnWidthPercentage) ? aBlock.columnWidthPercentage : ''"
                    class="angular-table-th" style="border-bottom: 1px solid rgba(0,0,0,.12);min-width: 180px;">
                    <div fxLayout="row" style="align-items: center;"
                      [style.justify-content]="aBlock.textHeadAlignment ? 'left' : 'center'">
                      <span *ngIf="aBlock.isRequired" style="color: red">* </span>
                      <span *ngIf="!aBlock.isTableColumnLabel" [innerHTML]="aBlock.label[selectedLanguage]"
                        [style.cursor]="aBlock.isSortable ? 'pointer' : ''"
                        [style.font-weight]="aBlock.sortActive ? 'bolder' : ''" (click)="sortRows(aBlock)"></span>
                      <span *ngIf="aBlock.isTableColumnLabel" [innerHTML]="aBlock.tableColumnLabel[selectedLanguage]"
                        [style.cursor]="aBlock.isSortable ? 'pointer' : ''"
                        [style.font-weight]="aBlock.sortActive ? 'bolder' : ''" (click)="sortRows(aBlock)"></span>
                      <span *ngIf="aBlock.isShowDateFormat" style="white-space: nowrap"><br>
                        ({{aBlock.dateFormatToBeShown[selectedLanguage]}})</span>
                      <mat-icon *ngIf="aBlock.isSortable && aBlock.sortActive" style="cursor: pointer"
                        (click)="sortRows(aBlock)">
                        {{aBlock.sortDirection === 'asc' ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}
                      </mat-icon>
                    </div>
                    <fb-tooltip *ngIf="aBlock.hasTooltip == true && !aBlock.hideTooltipHeader" [lang]="selectedLanguage"
                      [tooltipText]="aBlock.tooltipText"></fb-tooltip>
                    <span *ngIf="aBlock.hasDialog" style="padding-top: 10px;">
                      <mat-icon (click)="openDialog(aBlock)"
                        style="cursor: pointer; vertical-align: middle !important; margin-top: -2px !important;">help_outline</mat-icon>
                    </span>
                  </th>
                </ng-template>
                <th *ngIf="confChange.readOnlyTable" class="angular-table-th"> {{confChange.editLabel ?
                  confChange.editLabel[selectedLanguage] : '' }}</th>
                <th *ngIf="confChange.showDelete" class="angular-table-th"
                  style="text-align: center;padding-right: 10px !important; border-bottom: 1px solid rgba(0, 0, 0, 0.12); min-width: 80px; padding-bottom: 8px !important;">
                  {{confChange.deleteLabel[selectedLanguage]}}
                </th>
              </ng-container>
            </tr>
            <!-- HEADERS ROW END -->
          </thead>

          <!-- TABLE BODY START -->
          <tbody [hidden]="table.hidden">
            <ng-container *ngFor="let row of table.renderRows; let i = index">
              <tr [class]="row.isTotal ? 'active': (row.hasError ? 'hasError' : 'noError')" class="angular-table-tr"
                [style.display]="row.isHidden ? 'none' : ''"
                [style.background-color]="row.isActivateTableRowColor ? row.tableRowColor : ''"
                [style.font-weight]="row.isActivateTableRowFont ? row.tableRowFont : ''"
                style="border-bottom: 1px solid rgba(0,0,0,.12);">
                <ng-container
                  *ngTemplateOutlet="commonTableBody; context: {templateContext : row , rowIndex : i, table : table, tableIndex: tableIndex}">
                </ng-container>
              </tr>
              <ng-container *ngIf="!confChange.hideYearsExpenditure">
                <ng-container
                  *ngTemplateOutlet="yearsRow; context: {templateContext : row , rowIndex : i}"></ng-container>
              </ng-container>
              <ng-container
                *ngIf="!confChange.hideYearsExpenditure && !row.isTotal && !row.isCategoryTotal && !row.isSubCategoryTotal">
                <ng-container
                  *ngTemplateOutlet="columnAsRow; context: {templateContext : row , rowIndex : i, table : table, tableIndex: tableIndex}"></ng-container>
              </ng-container>
            </ng-container>
          </tbody>
          <!-- TABLE BODY END -->
        </ng-container>
      </table>
      <button *ngIf="!table.hidden && table.teamFunded === '1'" class='addBtn' mat-raised-button color="accent"
        style="margin: 10px 0" [disabled]="confChange.isReadOnlyField"
        (click)="addTableRow(bphChange, confChange, table, tableIndex)">
        {{ confChange.addRowLabel[selectedLanguage]}}
      </button>
    </ng-container>
  </ng-container>
</div>

<!-- SUMMARY TABLE START -->
<div
  *ngIf="confChange.showSummaryTable && !showAddEditTableForm && !confChange.showDetails && !bphChange.showDetails && !globalConf.showDetails"
  class="readOnlyTable" style="margin-top: 15px;">

  <table class="angular-table">

    <!-- SUMMARY TABLE HEADER START -->
    <tr class="angular-table-tr header-table">
      <th colspan="8">
        {{confChange.summaryTabelLabel[selectedLanguage]}}
      </th>
    </tr>
    <!-- SUMMARY TABLE HEADER END -->

    <!-- SUMMARY TABLE HEADERS START -->
    <tr class="angular-table-tr" style="background-color: #f0f0f0">
      <th class="summary-year-header">{{confChange.categoryLabel[selectedLanguage]}}</th>

      <th *ngIf="confChange.showSubCategoryInSummary" class="summary-year-header">
        {{confChange.subCategoryLabel[selectedLanguage]}}</th>

      <ng-container *ngIf="!confChange.hideYearsExpenditure" class="angular-table-th align-center">
        <ng-container *ngFor="let row of bphChange.yearRows | keyvalue">
          <th class="summary-year-header">{{confChange.yearLabel[selectedLanguage]}} {{+row.key + 1}}</th>
        </ng-container>
      </ng-container>

      <th class="summary-year-header">{{confChange.subtotalLabel[selectedLanguage]}}</th>
    </tr>
    <!-- SUMMARY TABLE HEADERS END -->

    <ng-container *ngFor="let row of bphChange?.summaryTable?.rows">

      <tr class="angular-table-tr subTotalStyles">
        <td class="angular-table-td"><span>{{row.categoryLabel[selectedLanguage]}}</span></td>

        <ng-container *ngIf="confChange.showSubCategoryInSummary">
          <td class="angular-table-td"><span>{{row.subCategoryLabel[selectedLanguage]}}</span></td>
        </ng-container>

        <ng-container *ngIf="!confChange.hideYearsExpenditure">
          <ng-container *ngFor="let yearRow of row?.yearRows;">
            <td class="angular-table-td">{{convertNumberToCurrencyFormat(yearRow.value, confChange.currency, confChange.removeFraction)}}</td>
          </ng-container>
        </ng-container>


        <td class="angular-table-td">{{convertNumberToCurrencyFormat(row?.rowTotal.value, confChange.currency, confChange.removeFraction)}}</td>

      </tr>
    </ng-container>

    <tr class="angular-table-tr totalStyles" style="background: #ccc !important; font-weight: bold">
      <td class="angular-table-td">{{confChange.grandTotalLabel[selectedLanguage]}}</td>
      <ng-container *ngIf="confChange.showSubCategoryInSummary">
        <td class="angular-table-td"></td>
      </ng-container>
      <ng-container *ngIf="!confChange.hideYearsExpenditure">
        <ng-container *ngFor="let yearTotal of bphChange.summaryTable?.yearTotals;">
          <td class="angular-table-td align-center">{{convertNumberToCurrencyFormat(yearTotal.value, confChange.currency)}}</td>
        </ng-container>
      </ng-container>
      <td class="angular-table-td">{{convertNumberToCurrencyFormat(bphChange.summaryTable?.grandSubTotal.value,
        confChange.currency, confChange.removeFraction)}}</td>
    </tr>

  </table>
</div>
<!-- SUMMARY TABLE END -->

<!-- BUDGET DETAIL ROW VIEW START -->
<div *ngIf="!bphChange.show && confChange.readOnlyTable && showAddEditTableForm" class="fb_table_dertails">

  <ng-container *ngFor="let subBlock of getFilteredSubBlocksDetailedView()">
    <ng-container [ngSwitch]="subBlock.templateName">
      <ng-container *ngSwitchCase="'statictext'">
        <ng-container
          *ngTemplateOutlet="statictext; context: {templateContext : subBlock.templateContext2 , rowIndex : i}"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'textarea'">
        <ng-container
          *ngTemplateOutlet="textarea; context: {templateContext : subBlock.templateContext2 , rowIndex : i}"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'Radiobutton'">
        <ng-container
          *ngTemplateOutlet="Radiobutton; context: {templateContext : subBlock.templateContext2 , rowIndex : i}"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'select'">
        <ng-container
          *ngTemplateOutlet="select; context: {templateContext : subBlock.templateContext2 , rowIndex : i}"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'SubmitButton'">
        <ng-container
          *ngTemplateOutlet="SubmitButton; context: {templateContext : subBlock.templateContext2 , rowIndex : i}"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'upload'">
        <ng-container
          *ngTemplateOutlet="upload; context: {templateContext : subBlock.templateContext2 , rowIndex : i, blockIndex : (blockIndex + ((i + 1) / 100))}"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'text'">
        <ng-container
          *ngTemplateOutlet="text; context: {templateContext : subBlock.templateContext2 , rowIndex : i}"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'Checkbox'">
        <ng-container
          *ngTemplateOutlet="Checkbox; context: {templateContext : subBlock.templateContext2 , rowIndex : i}"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'datepicker'">
        <ng-container
          *ngTemplateOutlet="datepicker; context: {templateContext : subBlock.templateContext2 , rowIndex : i}"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'AutoComplete'">
        <ng-container
          *ngTemplateOutlet="AutoComplete; context: {templateContext : subBlock.templateContext2 , rowIndex : i}"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'richtext'">
        <ng-container
          *ngTemplateOutlet="richtext; context: {templateContext : subBlock.templateContext2 , rowIndex : i}"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'button'">
        <ng-container
          *ngTemplateOutlet="button; context: {templateContext : subBlock.templateContext2 , rowIndex : i}"></ng-container>
      </ng-container>
      <ng-container *ngSwitchDefault></ng-container>
    </ng-container>
  </ng-container>

  <table id="budget_t1_table" class="angular-table showSecondTable" style="margin-bottom: 1.34375em;">
    <thead class="angular-table-thead">
      <tr class="angular-table-tr">
        <th class="angular-table-th" *ngIf="!confChange.hideYearsExpenditure">{{confChange.yearLabel[selectedLanguage]}}
        </th>
        <ng-container *ngFor="let item of expRowCompArrDetailExcludeRevision">
          <th class="angular-table-th">
            <span class="label-inline">
              {{item.item.label[selectedLanguage]}}
              <span *ngIf="item.item.hasDialog" style="padding-top: 10px;">
                <button type="button" mat-icon-button (click)="openDialog(item.item)"
                  style="margin-left: -10px;margin-bottom: -10px;">
                  <mat-icon
                    style="cursor: pointer; vertical-align: middle !important; margin-top: -2px !important;">help_outline</mat-icon></button>
              </span>
            </span>
          </th>
        </ng-container>
      </tr>
    </thead>

    <ng-container *ngFor="let expandableRows of tempRow.expandRows; let currRowIndex = index">
      <tr class="angular-table-tr">
        <td class="angular-table-td" *ngIf="!confChange.hideYearsExpenditure">{{expandableRows.label[selectedLanguage]}}
        </td>
        <ng-container
          *ngFor="let row of getExpRowsCheckRevisionMode(expandableRows.totalComps) ; let currColumnIndex = index ">
          <td class="angular-table-td" style="padding: 2px 18px;">
            <div class="subtotal-field"
              [ngClass]="row.error && row.error && row.error[selectedLanguage] ? 'hasError' : 'noError'">
              <mat-form-field appearance="outline"
                [ngClass]="row.error && row.error[selectedLanguage] ? 'ng-invalid mat-form-field-invalid' : ''">
                <input id="subtotal" matInput type="number" min="0" max="999999999"
                  [disabled]="row.item.isReadOnlyField"
                  (input)="row.value < 0 ? row.value = 0 : onSubTotalInput(bphChange.selectedTable, tempRow, currRowIndex,currColumnIndex, row, $event);"
                  [(ngModel)]="row.value" maxlength="9">
              </mat-form-field>
              <p class="counter-style" style="margin-top: 0px; text-align: right;">
                {{getTextLength2(row.value)}} / 9</p>
              <div *ngIf="row.error && row.error[selectedLanguage]" class="formFieldError">
                {{row.error[selectedLanguage]}}</div>
            </div>
          </td>
        </ng-container>

      </tr>
    </ng-container>
    <tr class="angular-table-tr" *ngIf="!confChange.hideYearsExpenditure">
      <td class="angular-table-td"><span>{{confChange.subtotalLabel[selectedLanguage]}}</span></td>
      <ng-container *ngFor="let item of expRowCompArrDetailExcludeRevision">
        <td class="angular-table-td">
          <span>{{convertNumberToCurrencyFormat(tempRow[item.item.name]?.value, confChange.currency, confChange.removeFraction)}}</span>
        </td>
      </ng-container>
    </tr>

  </table>

  <button (click)="closeDetails(confChange,bphChange)" mat-raised-button
    style=" background-color: #4FC3F7; color: #FFFFFF; margin-right: 1%">
    <span>{{getTranslatedLabel("ecase.common.save")}}</span>
  </button>
  <button (click)="cancel(confChange,bphChange)" color="accent"
    mat-raised-button><span>{{getTranslatedLabel("ecase.common.cancel")}}</span>
  </button>
</div>
<!-- BUDGET DETAIL ROW VIEW END -->

<ng-template #commonTableRows let-i="rowIndex" let-row="templateContext" let-table="table" let-tableIndex="tableIndex">

  <!-- Expand year rows cell -->
  <td class="angular-table-td" *ngIf="!confChange.hideYearsExpenditure">
    <mat-icon style="cursor: pointer; margin-right: 5px;" (click)="showTableRow(row, i)">
      {{row.isShowTableRow ? 'remove_circle_outline' : 'add_circle_outline'}}
    </mat-icon>
  </td>
  <!-- End Expand year rows cell -->

  <!-- All the row blocks from formbuilder -->
  <ng-container>
    <ng-container *ngFor="let subBlock of getFilteredSubBlocks()">
      <ng-container *ngIf="!subBlock.hideCell" [ngSwitch]="subBlock.templateName">
        <ng-container *ngSwitchCase="'statictext'">
          <ng-container
            *ngTemplateOutlet="statictext; context: {templateContext : subBlock.templateContext , rowIndex : i, table: table}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'textarea'">
          <ng-container
            *ngTemplateOutlet="textarea; context: {templateContext : subBlock.templateContext , rowIndex : i, table: table}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'Radiobutton'">
          <ng-container
            *ngTemplateOutlet="Radiobutton; context: {templateContext : subBlock.templateContext , rowIndex : i, table: table}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'select'">
          <ng-container
            *ngTemplateOutlet="select; context: {templateContext : subBlock.templateContext , rowIndex : i, table: table}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'Container'">
          <ng-container
            *ngTemplateOutlet="Container; context: {templateContext : subBlock.templateContext , rowIndex : i}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'Table'">
          <ng-container
            *ngTemplateOutlet="Table; context: {templateContext : subBlock.templateContext , rowIndex : i}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'SubmitButton'">
          <ng-container
            *ngTemplateOutlet="SubmitButton; context: {templateContext : subBlock.templateContext , rowIndex : i}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'upload'">
          <ng-container
            *ngTemplateOutlet="upload; context: {templateContext : subBlock.templateContext , rowIndex : i, table: table, blockIndex : (blockIndex + ((i + 1) / 100))}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'text'">
          <ng-container
            *ngTemplateOutlet="text; context: {templateContext : subBlock.templateContext , rowIndex : i, table: table}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'Checkbox'">
          <ng-container
            *ngTemplateOutlet="Checkbox; context: {templateContext : subBlock.templateContext , rowIndex : i, table: table}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'datepicker'">
          <ng-container
            *ngTemplateOutlet="datepicker; context: {templateContext : subBlock.templateContext , rowIndex : i, table: table}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'AutoComplete'">
          <ng-container
            *ngTemplateOutlet="AutoComplete; context: {templateContext : subBlock.templateContext , rowIndex : i, table: table}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'button'">
          <ng-container
            *ngTemplateOutlet="button; context: {templateContext : subBlock.templateContext , rowIndex : i}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'richtext'">
          <ng-container
            *ngTemplateOutlet="richtext; context: {templateContext : subBlock.templateContext , rowIndex : i}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchDefault></ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
  <!-- End All the row blocks from formbuilder -->

  <!-- Edit button cell in table rows view -->
  <td *ngIf="!confChange.hideEditButton" class="angular-table-td" style="text-align: center;">
    <button (click)="editRow(bphChange, confChange, row.renderPosition, tableIndex)" *ngIf="!row.rowEditButtonHide"
      [disabled]="confChange.isReadOnlyField || (bphChange.globalReadOnlyMode && bphChange.globalReadOnlyMode === 'true')"
      mat-icon-button>
      <mat-icon>create</mat-icon>
    </button>
  </td>
  <!-- End Edit button cell in table rows view -->

  <!-- Delete button cell in table rows view -->
  <td *ngIf="confChange.showDelete" class="angular-table-td" style="text-align: center;">
    <button (click)="deleteRow(bphChange, confChange, row.renderPosition, tableIndex)" *ngIf="!row.rowDeleteButtonHide"
      [disabled]="confChange.isReadOnlyField || row.isDeleteDisabled || (bphChange.globalReadOnlyMode && bphChange.globalReadOnlyMode === 'true')"
      [style.opacity]="(confChange.isReadOnlyField || row.isDeleteDisabled || (bphChange.globalReadOnlyMode && bphChange.globalReadOnlyMode === 'true')) ? 0.5 : 1"
      mat-icon-button>
      <mat-icon>delete</mat-icon>
    </button>
  </td>
  <!-- End Delete button cell in table rows view -->
</ng-template>

<!-- TOTAL ROW START -->
<ng-template #totalTableRows let-i="rowIndex" let-row="templateContext">

  <ng-container *ngIf="!confChange.hideYearsExpenditure">
    <ng-container *ngTemplateOutlet="greyColumn;"></ng-container>
  </ng-container>

  <ng-container *ngFor="let subBlock of getFilteredSubBlocks()">
    <ng-container *ngIf="!subBlock.hideCell">

      <!-- GREY CELL START -->
      <ng-container *ngIf="!subBlock.hasExpandRowsValues && !subBlock.subTotalLabelColumn">
        <ng-container *ngTemplateOutlet="greyColumn;"></ng-container>
      </ng-container>
      <!-- GREY CELL END -->

      <!-- LABEL CELL START -->
      <ng-container *ngIf="subBlock.subTotalLabelColumn">
        <td class="angular-table-td" style="background-color: lightgrey;">
          <span style="padding-top: 13px;width: 100%;font-weight: bold !important;">{{row.label[selectedLanguage] + "
            :"}}</span>
        </td>
      </ng-container>
      <!-- LABEL CELL END -->

      <!-- GRAND TOTAL CELL START -->
      <ng-container *ngIf="subBlock.hasExpandRowsValues">
        <td class="angular-table-td" style="font-weight: bold !important;background-color: lightgrey;">
          <div>
            <span>{{convertNumberToCurrencyFormat((row?.[subBlock?.name]?.value || 0), confChange.currency, confChange.removeFraction)}}</span>
          </div>
        </td>
      </ng-container>
      <!-- GRAND TOTAL CELL END -->
    </ng-container>
  </ng-container>

  <ng-container *ngTemplateOutlet="greyColumn;"></ng-container>
  <ng-container *ngTemplateOutlet="greyColumn;"></ng-container>

</ng-template>
<!-- TOTAL ROW END -->

<!-- TABLE BODY START -->
<ng-template #commonTableBody let-i="rowIndex" let-row="templateContext" let-table="table" let-tableIndex="tableIndex">

  <!-- Common table row with data -->
  <ng-container *ngIf="row.uniqueRowIndex">
    <ng-container
      *ngTemplateOutlet="commonTableRows; context: {templateContext: row, rowIndex: i, table: table, tableIndex: tableIndex}"></ng-container>
  </ng-container>
  <!-- End Common table row with data -->

  <!-- Total table row with data -->
  <ng-container *ngIf="row.isTotal">
    <ng-container *ngTemplateOutlet="totalTableRows; context: {templateContext: row, rowIndex: i}"></ng-container>
  </ng-container>
  <!-- End Total table row with data -->

  <!-- Category and Subcategory total row with data -->
  <ng-container
    *ngIf="(row.isCategoryTotal && confChange.showCategoriesTotal) || (row.isSubCategoryTotal && confChange.showSubCategoriesTotal)">
    <ng-container *ngTemplateOutlet="subTotalRows; context: {templateContext: row, rowIndex: i}"></ng-container>
  </ng-container>
  <!-- End Category and Subcategory row with data -->

</ng-template>
<!-- TABLE BODY END -->

<!-- YEARS ROW START -->
<ng-template #yearsRow let-i="rowIndex" let-row="templateContext">
  <ng-container *ngIf="row.isShowTableRow && !row.isTotal && !row.isCategoryTotal && !row.isSubCategoryTotal">
    <tr class="angular-table-tr" *ngFor="let expandRow of row.expandRows">

      <ng-container *ngIf="!confChange.hideYearsExpenditure">
        <ng-container *ngTemplateOutlet="greyColumn;"></ng-container>
      </ng-container>

      <ng-container *ngFor="let subBlock of getFilteredSubBlocks()">
        <ng-container *ngIf="!subBlock.hideCell">
          <td *ngIf="subBlock.subTotalLabelColumn" class="angular-table-td" style="background-color: lightgrey;">
            <span style="padding-top: 13px;width: 100%;">{{expandRow.label[selectedLanguage] + " :"}}</span>
          </td>

          <td *ngIf="subBlock.hasExpandRowsValues" class="angular-table-td" style="background-color: lightgrey;">
            <ng-container *ngFor="let item of expandRow.totalComps">
              <span *ngIf="item.item.name == subBlock.name"
                style="padding-top: 13px;width: 100%;">{{convertNumberToCurrencyFormat(item.value,
                confChange.currency, confChange.removeFraction)}}</span>
              <!--              <div-->
              <!--                [ngClass]="item?.value && item?.value.error && item?.value.error[selectedLanguage] ? 'hasError' : 'noError'">-->
              <!--                  <span *ngIf="item?.value && item?.value.error[selectedLanguage]"-->
              <!--                        class="tableFormFieldError">{{item?.value.error[selectedLanguage]}}-->
              <!--                  </span>-->
              <!--              </div>-->

            </ng-container>
          </td>

          <ng-container *ngIf="!subBlock.hasExpandRowsValues && !subBlock.subTotalLabelColumn">
            <ng-container *ngTemplateOutlet="greyColumn;"></ng-container>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngTemplateOutlet="greyColumn;"></ng-container>
      <ng-container *ngTemplateOutlet="greyColumn;"></ng-container>

    </tr>
  </ng-container>
</ng-template>
<!-- YEARS ROW END -->

<ng-template #columnAsRow let-i="rowIndex" let-row="templateContext" let-table="table" let-tableIndex="tableIndex">
  <ng-container *ngFor="let subBlock of getColumnAsRowSubBlocks()">
    <ng-container *ngIf="subBlock.type == 'textarea'">
      <tr>
        <td class="angular-table-td">
          <span style="padding-top: 13px;width: 100%;"></span>
        </td>
        <td class="angular-table-td">
          <span *ngIf="subBlock.isRequired" style="color: red">* </span>
          <span style="padding-top: 13px;width: 100%;">{{subBlock.label[selectedLanguage]}}</span>
        </td>
        <td [attr.colspan]="getColumnAsRowColspan()" class="angular-table-td" style="text-align: left !important;">
          <span style="padding-top: 13px;width: 100%;">{{ ( row[subBlock.name] && row[subBlock.name]['value'] ) ?
            row[subBlock.name]['value'] : '' }}</span>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</ng-template>

<!-- CATEGORY AND SUBCATEGORY SUBTOTALS ROW START -->
<ng-template #subTotalRows let-i="rowIndex" let-row="templateContext">

  <ng-container *ngIf="!confChange.hideYearsExpenditure">
    <ng-container *ngTemplateOutlet="greyColumn;"></ng-container>
  </ng-container>

  <ng-container *ngFor="let subBlock of getFilteredSubBlocks()">
    <ng-container *ngIf="!subBlock.hideCell">

      <ng-container *ngIf="subBlock.subTotalLabelColumn">
        <td class="angular-table-td" style="background-color: lightgrey;">
          <span style="padding-top: 13px;width: 100%;">{{row.label[selectedLanguage] + " :"}}</span>
        </td>
      </ng-container>

      <ng-container *ngIf="subBlock.hasExpandRowsValues">
        <td class="angular-table-td" style="background-color: lightgrey;">
          <div>
            <span>{{convertNumberToCurrencyFormat((row?.[subBlock?.name]?.value || 0), confChange.currency, confChange.removeFraction)}}</span>
          </div>
        </td>
      </ng-container>

      <ng-container *ngIf="!subBlock.hasExpandRowsValues && !subBlock.subTotalLabelColumn">
        <ng-container *ngTemplateOutlet="greyColumn;"></ng-container>
      </ng-container>

    </ng-container>
  </ng-container>

  <ng-container *ngTemplateOutlet="greyColumn;"></ng-container>
  <ng-container *ngTemplateOutlet="greyColumn;"></ng-container>

</ng-template>
<!-- CATEGORY AND SUBCATEGORY SUBTOTALS ROW END -->

<ng-template #SubmitButton let-confChange="templateContext.confChange" let-isValidHtml="templateContext.isValidHtml"
  let-isValidTable="templateContext.isValidTable" let-isValidTableReadonly="templateContext.isValidTableReadonly"
  let-rowIndex="rowIndex">
  <fb-submit-button
    [bphChange]='(!rowIndex && rowIndex !== 0) ? (bphChange.rows[selectedTableRowIndex])[confChange.name] : (!rowIndex && rowIndex !== 0) ? (bphChange.rows[selectedTableRowIndex])[confChange.name] : (bphChange.renderRows[rowIndex])[confChange.name]'
    [confChange]='confChange' [globalConf]='globalConf' [globalPrj]='globalPrj' [isValidHtml]='isValidHtml'
    [isValidTableReadonly]='isValidTableReadonly' [isValidTable]='isValidTable' [selectedLanguage]='selectedLanguage'
    [selectedSectionId]='selectedSectionId'
    [style.width.%]="(tableConfChange.isWidthSpecifiedForSubBlocks && confChange.columnWidthPercentage) ? confChange.columnWidthPercentage : ''"
    style='position: static;display: table-cell;vertical-align: middle;padding-right:20px;'></fb-submit-button>
</ng-template>
<ng-template #statictext let-confChange="templateContext.confChange" let-isValidHtml="templateContext.isValidHtml"
  let-isValidTable="templateContext.isValidTable" let-isValidTableReadonly="templateContext.isValidTableReadonly"
  let-rowIndex="rowIndex" let-table="table">
  <fb-static-text
    [bphChange]='(!rowIndex && rowIndex !== 0) ? (selectedTable.rows[selectedTableRowIndex])[confChange.name] : (table.renderRows[rowIndex])[confChange.name]'
    [confChange]='confChange' [globalConf]='globalConf' [globalPrj]='globalPrj' [isValidHtml]='isValidHtml'
    [isValidTableReadonly]='isValidTableReadonly' [isValidTable]='isValidTable' [selectedLanguage]='selectedLanguage'
    [rowNumber]="(!rowIndex && rowIndex !== 0) ? selectedTableRowIndex : rowIndex"
    [style.width.%]="(tableConfChange.isWidthSpecifiedForSubBlocks && confChange.columnWidthPercentage) ? confChange.columnWidthPercentage : ''"
    [style]="(!rowIndex && rowIndex !== 0) ? 'position: static;' : 'position: static;display: table-cell;vertical-align: middle;'">
  </fb-static-text>
</ng-template>
<ng-template #textarea let-confChange="templateContext.confChange" let-isValidHtml="templateContext.isValidHtml"
  let-isValidTable="templateContext.isValidTable" let-isValidTableReadonly="templateContext.isValidTableReadonly"
  let-rowIndex="rowIndex" let-table="table">
  <fb-text-area
    [bphChange]='(!rowIndex && rowIndex !== 0) ? (selectedTable.rows[selectedTableRowIndex])[confChange.name] : (table.renderRows[rowIndex])[confChange.name]'
    [confChange]='confChange' [globalConf]='globalConf' [globalPrj]='globalPrj' [isValidHtml]='isValidHtml'
    [isValidTableReadonly]='isValidTableReadonly' [isValidTable]='isValidTable' [selectedLanguage]='selectedLanguage'
    [style.width.%]="(tableConfChange.isWidthSpecifiedForSubBlocks && confChange.columnWidthPercentage) ? confChange.columnWidthPercentage : ''"
    [style]="(!rowIndex && rowIndex !== 0) ? 'position: static;' : 'position: static;display: table-cell;vertical-align: middle;'">
  </fb-text-area>
</ng-template>
<ng-template #Radiobutton let-confChange="templateContext.confChange" let-isValidHtml="templateContext.isValidHtml"
  let-isValidTable="templateContext.isValidTable" let-isValidTableReadonly="templateContext.isValidTableReadonly"
  let-rowIndex="rowIndex" let-table="table">
  <fb-radiobutton (emitOutputEvent)='(confChange.enableOutputEvent) ? executeFunction(
                   confChange,
                   ((!rowIndex && rowIndex !== 0) ? (selectedTable.rows[selectedTableRowIndex])[confChange.name] : (table.renderRows[rowIndex])[confChange.name]),
                   ((!rowIndex && rowIndex !== 0) ? selectedTableRowIndex : rowIndex)) : doNothing()'
    [bphChange]='(!rowIndex && rowIndex !== 0) ? (selectedTable.rows[selectedTableRowIndex])[confChange.name] : (table.renderRows[rowIndex])[confChange.name]'
    [confChange]='confChange' [globalConf]='globalConf' [globalPrj]='globalPrj' [isValidHtml]='isValidHtml'
    [isValidTableReadonly]='isValidTableReadonly' [isValidTable]='isValidTable' [selectedLanguage]='selectedLanguage'
    [style.width.%]="(tableConfChange.isWidthSpecifiedForSubBlocks && confChange.columnWidthPercentage) ? confChange.columnWidthPercentage : ''"
    [style]="(!rowIndex && rowIndex !== 0) ? 'position: static;' : 'position: static;display: table-cell;vertical-align: middle;'">
  </fb-radiobutton>
</ng-template>
<ng-template #select let-confChange="templateContext.confChange" let-isValidHtml="templateContext.isValidHtml"
  let-isValidTable="templateContext.isValidTable" let-isValidTableReadonly="templateContext.isValidTableReadonly"
  let-rowIndex="rowIndex" let-table="table">
  <fb-select (emitOutputEvent)='(confChange.isEnableOutputEvent) ? executeFunction(
                   confChange,
                   ((!rowIndex && rowIndex !== 0) ? (selectedTable.rows[selectedTableRowIndex])[confChange.name] : (table.renderRows[rowIndex])[confChange.name]),
                   ((!rowIndex && rowIndex !== 0) ? selectedTableRowIndex : rowIndex)) : doNothing()'
    *ngIf="!isValidTableReadonly"
    [bphChange]='((!rowIndex && rowIndex !== 0) ? (selectedTable.rows[selectedTableRowIndex])[confChange.name] : (table.renderRows[rowIndex])[confChange.name])'
    [confChange]='confChange' [globalConf]='globalConf' [globalPrj]='globalPrj' [isValidHtml]='isValidHtml'
    [isValidTableReadonly]='isValidTableReadonly' [isValidTable]='isValidTable'
    [rowNumber]="(!rowIndex && rowIndex !== 0) ? selectedTableRowIndex : rowIndex" [selectedLanguage]='selectedLanguage'
    [selectedSectionId]='selectedSectionId'
    [style.width.%]="(tableConfChange.isWidthSpecifiedForSubBlocks && confChange.columnWidthPercentage) ? confChange.columnWidthPercentage : ''"
    [style]="(!rowIndex && rowIndex !== 0) ? 'position: static;' : 'position: static;display: table-cell;vertical-align: middle;'">
  </fb-select>

  <ng-container
    *eCaseVar="(((!rowIndex && rowIndex !== 0) ? (selectedTable.rows[selectedTableRowIndex])[confChange.name] : (table.renderRows[rowIndex])[confChange.name]) ? ((!rowIndex && rowIndex !== 0) ? (selectedTable.rows[selectedTableRowIndex])[confChange.name] : (table.renderRows[rowIndex])[confChange.name]) : {}) as componentBphChange">
    <td *ngIf="isValidTableReadonly && !componentBphChange.hideCell && !confChange.hideCell"
      [attr.rowspan]="componentBphChange.rowspan"
      [ngClass]="(componentBphChange?.error && componentBphChange?.error[selectedLanguage]) ? 'hasError' : 'noError'"
      [style.border-right]="(componentBphChange.rowspan && componentBphChange.rowspan > 1) ? '1px solid rgba(0, 0, 0, .12)' : ''"
      [style.text-align]=" confChange.align ? confChange.align +'!important' : 'center !important'"
      [style.padding-left]=" confChange.align ? '' : '10px'" [style.font-weightr]="confChange.align  ? 'bold' : ''"
      [style.width.%]="confChange.isWidthCustom ? confChange.customWidthInPercentage : (100 / widthDividerForDynamicWidth)"
      style="border:0;text-align: center;padding-right:10px ;border-bottom: 1px solid rgba(0, 0, 0, 0.12); min-width: 80px;">
      <div class="field {{componentBphChange.error_class}} hide_{{bphChange.show}}">
        {{getValueForFbSelectSubBlock(componentBphChange, selectedLanguage)}}
        <span *ngIf="confChange.showOtherValueInReadOnlyTable">
          <br>{{getOtherValueForFbSelectSubBlock(componentBphChange)}}
        </span>
        <span *ngIf="(componentBphChange?.error && componentBphChange?.error[selectedLanguage])"
          class="tableFormFieldError">{{componentBphChange.error[selectedLanguage]}}</span>
      </div>
    </td>
  </ng-container>
</ng-template>
<ng-template #text let-confChange="templateContext.confChange" let-isValidHtml="templateContext.isValidHtml"
  let-isValidTable="templateContext.isValidTable" let-isValidTableReadonly="templateContext.isValidTableReadonly"
  let-rowIndex="rowIndex" let-table="table">
  <fb-text (keydown.enter)='handleEnterKey($event, confChange)' (emitOutputEvent)='(confChange.enableOutputEvent) ? executeFunction(
                   confChange,
                   ((!rowIndex && rowIndex !== 0) ? (selectedTable.rows[selectedTableRowIndex])[confChange.name] : (table.renderRows[rowIndex])[confChange.name]),
                   ((!rowIndex && rowIndex !== 0) ? selectedTableRowIndex : rowIndex)) : doNothing()'
    [bphChange]='(!rowIndex && rowIndex !== 0) ? (selectedTable.rows[selectedTableRowIndex])[confChange.name] : (table.renderRows[rowIndex])[confChange.name]'
    [confChange]='confChange' [globalConf]='globalConf' [globalPrj]='globalPrj' [isValidHtml]='isValidHtml'
    [isValidTableReadonly]='isValidTableReadonly' [isValidTable]='isValidTable'
    [rowNumber]="(!rowIndex && rowIndex !== 0) ? selectedTableRowIndex : rowIndex" [selectedLanguage]='selectedLanguage'
    [selectedSectionId]='selectedSectionId'
    [style.background-color]="confChange.backgroundColor ? confChange.backgroundColor : ''"
    [style.width.%]="(tableConfChange.isWidthSpecifiedForSubBlocks && confChange.columnWidthPercentage) ? confChange.columnWidthPercentage : ''"
    [style]="(!rowIndex && rowIndex !== 0) ? 'position: static;' : 'position: static;display: table-cell;vertical-align: middle;'"
    [style.background-color]="confChange.backgroundColor ? confChange.backgroundColor : ''">
  </fb-text>
</ng-template>
<ng-template #upload let-confChange="templateContext.confChange" let-isValidHtml="templateContext.isValidHtml"
  let-isValidTable="templateContext.isValidTable" let-blockIndex="blockIndex"
  let-isValidTableReadonly="templateContext.isValidTableReadonly" let-rowIndex="rowIndex" let-table="table">
  <fb-upload (emitOutputEvent)='(confChange.enableOutputEvent) ? executeFunction(
                   confChange,
                   ((!rowIndex && rowIndex !== 0) ? (selectedTable.rows[selectedTableRowIndex])[confChange.name] : (table.renderRows[rowIndex])[confChange.name]),
                   ((!rowIndex && rowIndex !== 0) ? selectedTableRowIndex : rowIndex)) : doNothing()'
    [bphChange]='(!rowIndex && rowIndex !== 0) ? (selectedTable.rows[selectedTableRowIndex])[confChange.name] : (table.renderRows[rowIndex])[confChange.name]'
    [confChange]='confChange' [globalConf]='globalConf' [globalPrj]='globalPrj' [isValidHtml]='isValidHtml'
    [isValidTableReadonly]='isValidTableReadonly' [isValidTable]='isValidTable'
    [offlineModeEnabled]='offlineModeEnabled' [selectedLanguage]='selectedLanguage' [blockIndex]='blockIndex'
    [style.width.%]="(tableConfChange.isWidthSpecifiedForSubBlocks && confChange.columnWidthPercentage) ? confChange.columnWidthPercentage : ''"
    [style]="(!rowIndex && rowIndex !== 0) ? 'position: static;' : 'position: static;display: table-cell;vertical-align: middle;'">
  </fb-upload>
</ng-template>
<ng-template #button let-confChange="templateContext.confChange" let-isValidHtml="templateContext.isValidHtml"
  let-isValidTable="templateContext.isValidTable" let-isValidTableReadonly="templateContext.isValidTableReadonly"
  let-rowIndex="rowIndex">
  <fb-button
    [bphChange]='(!rowIndex && rowIndex !== 0) ? (bphChange.rows[selectedTableRowIndex])[confChange.name] : (bphChange.renderRows[rowIndex])[confChange.name]'
    [sections]="sections" [confChange]='confChange' [globalConf]='globalConf' [globalPrj]='globalPrj'
    [isValidHtml]='isValidHtml' [isValidTableReadonly]='isValidTableReadonly' [isValidTable]='isValidTable'
    [offlineModeEnabled]='offlineModeEnabled'
    [rowNumber]="(!rowIndex && rowIndex !== 0) ? selectedTableRowIndex : rowIndex" [selectedLanguage]='selectedLanguage'
    [style.width.%]="(tableConfChange.isWidthSpecifiedForSubBlocks && confChange.columnWidthPercentage) ? confChange.columnWidthPercentage : ''"
    [style]="(!rowIndex && rowIndex !== 0) ? 'position: static;' : 'position: static;display: table-cell;vertical-align: middle;'">
  </fb-button>
</ng-template>
<ng-template #Checkbox let-confChange="templateContext.confChange" let-isValidHtml="templateContext.isValidHtml"
  let-isValidTable="templateContext.isValidTable" let-isValidTableReadonly="templateContext.isValidTableReadonly"
  let-rowIndex="rowIndex" let-table="table">
  <fb-checkbox (emitOutputEvent)='(confChange.enableOutputEvent) ? executeFunction(
                   confChange,
                   ((!rowIndex && rowIndex !== 0) ? (selectedTable.rows[selectedTableRowIndex])[confChange.name] : (table.renderRows[rowIndex])[confChange.name]),
                   ((!rowIndex && rowIndex !== 0) ? selectedTableRowIndex : rowIndex)) : doNothing()'
    [bphChange]='(!rowIndex && rowIndex !== 0) ? (selectedTable.rows[selectedTableRowIndex])[confChange.name] : (table.renderRows[rowIndex])[confChange.name]'
    [confChange]='confChange' [globalConf]='globalConf' [globalPrj]='globalPrj' [isValidHtml]='isValidHtml'
    [isValidTableReadonly]='isValidTableReadonly' [isValidTable]='isValidTable' [selectedLanguage]='selectedLanguage'
    [style.width.%]="(tableConfChange.isWidthSpecifiedForSubBlocks && confChange.columnWidthPercentage) ? confChange.columnWidthPercentage : ''"
    [style]="(!rowIndex && rowIndex !== 0) ? 'position: static;' : 'position: static;display: table-cell;vertical-align: middle;'">
  </fb-checkbox>
</ng-template>
<ng-template #datepicker let-confChange="templateContext.confChange" let-isValidHtml="templateContext.isValidHtml"
  let-isValidTable="templateContext.isValidTable" let-isValidTableReadonly="templateContext.isValidTableReadonly"
  let-rowIndex="rowIndex" let-table="table">
  <fb-datepicker (emitOutputEvent)='(confChange.enableOutputEvent) ? executeFunction(
                   confChange,
                   ((!rowIndex && rowIndex !== 0) ? (selectedTable.rows[selectedTableRowIndex])[confChange.name] : (table.renderRows[rowIndex])[confChange.name]),
                   ((!rowIndex && rowIndex !== 0) ? selectedTableRowIndex : rowIndex)) : doNothing()'
    [bphChange]='(!rowIndex && rowIndex !== 0) ? (selectedTable.rows[selectedTableRowIndex])[confChange.name] : (table.renderRows[rowIndex])[confChange.name]'
    [confChange]='confChange' [globalConf]='globalConf' [globalPrj]='globalPrj' [isValidHtml]='isValidHtml'
    [isValidTableReadonly]='isValidTableReadonly' [isValidTable]='isValidTable' [selectedLanguage]='selectedLanguage'
    [selectedSectionId]='selectedSectionId'
    [style.width.%]="(tableConfChange.isWidthSpecifiedForSubBlocks && confChange.columnWidthPercentage) ? confChange.columnWidthPercentage : ''"
    [style]="(!rowIndex && rowIndex !== 0) ? 'position: static;' : 'position: static;display: table-cell;vertical-align: middle;'">
  </fb-datepicker>
</ng-template>
<ng-template #AutoComplete let-confChange="templateContext.confChange" let-isValidHtml="templateContext.isValidHtml"
  let-isValidTable="templateContext.isValidTable" let-isValidTableReadonly="templateContext.isValidTableReadonly"
  let-rowIndex="rowIndex" let-table="table">
  <fb-autoComplete (emitOutputEvent)='(confChange.enableOutputEvent) ? executeFunction(
                   confChange,
                   ((!rowIndex && rowIndex !== 0) ? (selectedTable.rows[selectedTableRowIndex])[confChange.name] : (table.renderRows[rowIndex])[confChange.name]),
                   ((!rowIndex && rowIndex !== 0) ? selectedTableRowIndex : rowIndex)) : doNothing()'
    [bphChange]='(!rowIndex && rowIndex !== 0) ? (selectedTable.rows[selectedTableRowIndex])[confChange.name] : (table.renderRows[rowIndex])[confChange.name]'
    [confChange]='confChange' [globalConf]='globalConf' [globalPrj]='globalPrj' [isValidHtml]='isValidHtml'
    [isValidTableReadonly]='isValidTableReadonly' [isValidTable]='isValidTable'
    [rowNumber]="(!rowIndex && rowIndex !== 0) ? selectedTableRowIndex : rowIndex" [selectedLanguage]='selectedLanguage'
    [selectedSectionId]='selectedSectionId'
    [style.width.%]="(tableConfChange.isWidthSpecifiedForSubBlocks && confChange.columnWidthPercentage) ? confChange.columnWidthPercentage : ''"
    [style]="(!rowIndex && rowIndex !== 0) ? 'position: static;' : 'position: static;display: table-cell;vertical-align: middle;'">
  </fb-autoComplete>
</ng-template>
<ng-template #richtext let-confChange="templateContext.confChange" let-isValidHtml="templateContext.isValidHtml"
  let-isValidTable="templateContext.isValidTable" let-isValidTableReadonly="templateContext.isValidTableReadonly"
  let-rowIndex="rowIndex">
  <fb-rich-text-quill
    [bphChange]='(!rowIndex && rowIndex !== 0) ? (bphChange.rows[selectedTableRowIndex])[confChange.name] : (bphChange.renderRows[rowIndex])[confChange.name]'
    [confChange]='confChange' [globalConf]='globalConf' [globalPrj]='globalPrj' [isValidHtml]='isValidHtml'
    [isValidTableReadonly]='isValidTableReadonly' [isValidTable]='isValidTable'
    [rowNumber]="(!rowIndex && rowIndex !== 0) ? selectedTableRowIndex : rowIndex" [selectedLanguage]='selectedLanguage'
    [selectedSectionId]='selectedSectionId'
    [style.width.%]="(tableConfChange.isWidthSpecifiedForSubBlocks && confChange.columnWidthPercentage) ? confChange.columnWidthPercentage : ''"
    [style]="(!rowIndex && rowIndex !== 0) ? 'position: static;' : 'position: static;display: table-cell;vertical-align: middle;'">
  </fb-rich-text-quill>
</ng-template>

<!-- Template to render grey columns in a table -->
<ng-template #greyColumn>
  <td class="angular-table-td" style="background-color: lightgrey;"></td>
</ng-template>
